<template>
  <v-dialog
    v-model="showModal"
    max-width="800"
  >
    <v-card
      outlined
      color="#ECEFF1"
    >
      <br>
      <h2 class="title-style">
        <v-icon
          left
          class="icon-style"
        >
          mdi-database-plus
        </v-icon>Add Prices
      </h2>
      <v-form ref="form">
        <v-container>
          <v-card-text class="text-body-1 text-center">
            <v-row
              class="fill-height"
            >
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="pricingName"
                  :rules="[(v) => !!v || 'This field is required']"
                  label=" Pricing Name"
                  dense
                  hint="Name for your reference- 'AUD - Yearly'"
                  persistent-hint
                  outlined
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-autocomplete
                  v-model="taxBehavior"
                  :rules="[(v) => !!v || 'Default tax behaviour is exclusive']"
                  :items="['inclusive', 'exclusive', 'unspecified']"
                  hint="Default tax behaviour setting is 'exclusive'. For more clarification contact your manager or refer M-001."
                  persistent-hint
                  label="Tax Behavior"
                  outlined
                  dense
                  disabled
                />
              </v-col>
            </v-row>
            <v-row class="fill-height">
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="amount"
                  type="number"
                  :rules="[(v) => !!v || 'This field is required']"
                  label="Amount"
                  dense
                  persistent-hint
                  hint="Amount should be of cents/paise."
                  outlined
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-autocomplete
                  v-model="currency"
                  :rules="[(v) => !!v || 'This field is required']"
                  :items="['usd', 'aud', 'inr']"
                  label="Currency"
                  outlined
                  dense
                />
              </v-col>
            </v-row>
            <v-row class="fill-height">
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  v-model="displayPrice"
                  :rules="[(v) => !!v || 'This field is required']"
                  label="Display Price"
                  dense
                  hint="Provide monthly price value- '6.99' (For your reference)."
                  persistent-hint
                  outlined
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-autocomplete
                  v-model="pricingPeriod"
                  :rules="[(v) => !!v || 'This field is required']"
                  :items="pricingPeriods"
                  item-text="name"
                  item-value="period"
                  label="Pricing Period"
                  outlined
                  dense
                />
              </v-col>
            </v-row>
            <v-row class="fill-height">
              <v-col
                cols="12"
              >
                <v-textarea
                  v-model="displayDescription"
                  auto-grow
                  rows="3"
                  row-height="25"
                  filled
                  label="Display Description"
                  hint="Pricing plan offer description- 'Save upto 20%' (For your reference)."
                  persistent-hint
                />
              </v-col>
            </v-row>
            <v-row
              class="fill-height"
              align-content="center"
              justify="center"
            >
              <h2 class="radio-label">
                Pricing Type
              </h2>
            </v-row>
            <v-row
              class="fill-height"
              align-content="center"
              justify="center"
            >
              <v-radio-group
                v-model="pricingType"
                row
                :rules="[(v) => !!v || 'This field is required']"
                align-content="center"
                justify="center"
                @change="PricingTypeChanged()"
              >
                <v-radio
                  label="One Time "
                  value="one_time"
                />
                <v-radio
                  label="Recurring"
                  value="recurring"
                />
              </v-radio-group>
            </v-row>
            <v-row class="fill-height">
              <v-col
                cols="12"
                md="6"
              >
                <v-autocomplete
                  ref="clearUsageType"
                  v-model="usageType"
                  :rules="pricingType == 'recurring' ? [(v) => !!v || 'This field is required'] : []"
                  :items="['licensed', 'metered']"
                  label="Usage Type"
                  :disabled="isRecurringSelected"
                  outlined
                  dense
                  @change="UsageTypeChanged()"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-autocomplete
                  ref="clearAggregateUsage"
                  v-model="aggregateUsage"
                  :rules="usageType == 'metered' ? [(v) => !!v || 'This field is required'] : []"
                  :items="selectAggregateUsage"
                  item-text="name"
                  item-value="id"
                  label="Aggregate Usage"
                  :disabled="!isLicensedSelected "
                  outlined
                  dense
                />
              </v-col>
            </v-row>
            <v-row class="fill-height">
              <v-col
                cols="12"
                md="6"
              >
                <v-autocomplete
                  ref="clearInterval"
                  v-model="interval"
                  :rules="pricingType == 'recurring' ? [(v) => !!v || 'This field is required'] : []"
                  :items="['day', 'week', 'month','year']"
                  label="Interval"
                  outlined
                  :disabled="isRecurringSelected"
                  outline
                  dense
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-text-field
                  ref="clearIntervalCount"
                  v-model="intervalCount"
                  :rules="pricingType == 'recurring' ? [(v) => !!v || 'This field is required'] : []"
                  type="number"
                  label="Interval Count"
                  :disabled="isRecurringSelected"
                  outlined
                  dense
                />
              </v-col>
            </v-row>
            <br>
            <v-row
              class="fill-height"
            >
              <v-col
                cols="12"
                md="12"
              >
                <v-switch
                  v-model="status"
                  class="ma-2 pa-0"
                  label="Price Status"
                  :persistent-hint="true"
                  color="#FF3700"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn
              class="mt-2"
              color="red darken-3"
              @click="showModal = false"
            >
              cancel
            </v-btn>
            <v-spacer />
            <v-btn
              class="mt-2"
              color="#FF3700"
              @click="addPrice()"
            >
              add
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-form>
      <centre-spinner
        :loading="loading"
      />
    </v-card>
  </v-dialog>
</template>
<script>
  import Constants from 'src/constants';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';

  export default {
    components: {
      'centre-spinner': spinner,
    },
    data () {
      return {
        pricingName: '',
        amount: null,
        currency: '',
        taxBehavior: 'exclusive',
        pricingType: '',
        usageType: '',
        aggregateUsage: null,
        interval: '',
        intervalCount: '',
        status: false,
        loading: false,
        showModal: true,
        productId: '',
        selectAggregateUsage: [
          { name: 'sum', id: 'sum' },
          { name: 'last during period', id: 'last_during_period' },
          { name: 'last ever', id: 'last_ever' },
          { name: 'max', id: 'max' },
        ],
        displayPrice: '',
        pricingPeriod: '',
        pricingPeriods: [
          { name: '1 Year', period: 'yearly' },
          { name: '3 Year', period: 'threeYearly' },
        ],
        displayDescription: null,
      };
    },
    computed: {
      isRecurringSelected () {
        if (this.pricingType !== 'recurring') {
          return true;
        }
        return false;
      },
      isLicensedSelected () {
        if (this.usageType === 'metered' && this.pricingType === 'recurring') {
          return true;
        }
        return false;
      },
    },
    watch: {
      showModal: function (newval, oldval) {
        if (newval === false) {
          this.$emit('closed');
        }
      },
    },
    methods: {
      addPrice () {
        if (this.$refs.form.validate() === true) {
          this.productId = this.$route.params.productid;
          this.loading = true;
          if ((this.pricingType === 'recurring')) {
            this.$store.dispatch('payments/addPrices', {
              priceDetails: {
                nick_name: this.pricingName,
                amount: parseInt(this.amount),
                currency: this.currency,
                tax_behavior: this.taxBehavior,
                pricing_type: this.pricingType,
                active: this.status,
                display_price: this.displayPrice,
                display_description: this.displayDescription,
                pricing_period: this.pricingPeriod,
                recurring_price: {
                  aggregate_usage: this.aggregateUsage,
                  interval: this.interval,
                  interval_count: parseInt(this.intervalCount),
                  usage_type: this.usageType,
                },
              },
              productId: this.productId,
            }).then(response => {
              this.$store.dispatch('alert/onAlert', {
                message: 'Price added  successfully.',
                type: Constants.ALERT_TYPE_SUCCESS,
              });
              this.$emit('get-price-details');
              this.loading = false;
              this.showModal = false;
            }).catch(() => {
              this.loading = false;
            });
          } else {
            this.$store.dispatch('payments/addPrices', {
              priceDetails: {
                nick_name: this.pricingName,
                amount: parseInt(this.amount),
                currency: this.currency,
                tax_behavior: this.taxBehavior,
                pricing_type: this.pricingType,
                active: this.status,
                display_price: this.displayPrice,
                display_description: this.displayDescription,
                pricing_period: this.pricingPeriod,
              },
              productId: this.productId,
            }).then(response => {
              this.$store.dispatch('alert/onAlert', {
                message: 'Price added  successfully.',
                type: Constants.ALERT_TYPE_SUCCESS,
              });
              this.$emit('get-price-details');
              this.loading = false;
              this.showModal = false;
            }).catch(() => {
              this.loading = false;
            });
          }
        }
      },
      PricingTypeChanged () {
        if (this.pricingType === 'one_time') {
          this.$refs.clearUsageType.reset();
          this.$refs.clearInterval.reset();
          this.$refs.clearIntervalCount.reset();
          this.$refs.clearAggregateUsage.reset();
        }
      },
      UsageTypeChanged () {
        if (this.usageType === 'licensed') {
          this.$refs.clearAggregateUsage.reset();
        }
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 30px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.radio {
  border: 1px;
}
.radio-label {
  margin-bottom: 10px;
  color: #37474F;
  font-weight: bold;
}
.v-input--selection-controls {
  margin-top: 1px;
  padding-top: 0px;
}
</style>
